<div class="card">
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input type="text" class="form-control form-control-sm w-250px ps-12" placeholder="Search invoices..."
          [(ngModel)]="searchTerm" (input)="onSearchInput($event)" />
      </div>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end align-items-center" data-table-toolbar="base">
        <!-- Multi-select dropdown for document types -->
        <div class="dropdown me-3" *ngIf="selectedInvoicesForCopy.length > 0">
          <button
            type="button"
            class="btn btn-sm btn-info dropdown-toggle"
            id="documentTypesDropdown"
            data-bs-toggle="dropdown"
            data-bs-auto-close="outside"
            aria-expanded="false">
            <i class="ki-duotone ki-document fs-2 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Select Documents
            <span class="badge badge-light ms-2" *ngIf="selectedDocumentTypes.length > 0">{{ selectedDocumentTypes.length }}</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end p-3" aria-labelledby="documentTypesDropdown" style="min-width: 280px;">
            <li class="mb-3">
              <div class="fw-bold text-gray-800 fs-6">Select Document Types</div>
              <div class="text-muted fs-7">Choose documents to send via email</div>
            </li>
            <li><hr class="dropdown-divider my-2"></li>
            <li *ngFor="let docType of documentTypes" class="mb-2">
              <div class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [id]="'doc_' + docType.value"
                  [checked]="isDocumentTypeSelected(docType.value)"
                  (change)="toggleDocumentType(docType.value)" />
                <label class="form-check-label cursor-pointer w-100" [for]="'doc_' + docType.value">
                  {{ docType.label }}
                </label>
              </div>
            </li>
          </ul>
        </div>

        <!-- Send Mail Button -->
        <button
          *ngIf="selectedInvoicesForCopy.length > 0"
          type="button"
          class="btn btn-sm btn-primary me-3"
          [disabled]="selectedInvoicesForCopy.length === 0 || selectedDocumentTypes.length === 0 || isSendingMail"
          (click)="openSendShippingMailModal()">
          <span class="spinner-border spinner-border-sm me-2" role="status" *ngIf="isSendingMail">
            <span class="visually-hidden">Loading...</span>
          </span>
          <i class="ki-duotone ki-sms fs-2" *ngIf="!isSendingMail">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          {{ isSendingMail ? 'Sending...' : 'Send Mail (' + selectedInvoicesForCopy.length + ')' }}
        </button>

        <!-- Copy ISL Button -->
        <button
          *ngIf="selectedInvoicesForCopy.length > 0"
          type="button"
          class="btn btn-sm btn-success me-3"
          [disabled]="selectedInvoicesForCopy.length === 0"
          (click)="copySelectedISL()">
          <i class="ki-duotone ki-copy fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Copy ISL# ({{ selectedInvoicesForCopy.length }})
        </button>

        <!-- Filter Button -->
        <button
          type="button"
          class="btn btn-sm btn-dark fw-bold d-flex me-3"
          [class.active]="showFilters"
          (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Filter</span>
          <span class="badge badge-danger ms-2" *ngIf="hasActiveFilters()">{{ getActiveFiltersCount() }}</span>
        </button>
        <button type="button" class="btn btn-sm btn-primary me-3 text-nowrap" (click)="exportExcel()" [disabled]="isExportingExcel">
          <span *ngIf="isExportingExcel" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          <i *ngIf="!isExportingExcel" class="ki-duotone ki-exit-up fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>{{ isExportingExcel ? 'Exporting...' : 'Export Excel' }}</span>
        </button>
        <button type="button" class="btn btn-sm btn-success me-3 text-nowrap" (click)="openExportFieldsModal()" [disabled]="isExportingSelectedFields">
          <span *ngIf="isExportingSelectedFields" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          <i *ngIf="!isExportingSelectedFields" class="ki-duotone ki-setting-2 fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>{{ isExportingSelectedFields ? 'Exporting...' : 'Export Selected Fields' }}</span>
        </button>
        <a href="#" class="btn btn-sm btn-dark me-3 text-nowrap">
          <i class="ki-duotone ki-cloud-download fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Download</span>
        </a>

      </div>
      <div class="d-flex justify-content-end align-items-center d-none" data-table-toolbar="selected">
        <div class="fw-bold me-5">
          <span class="me-2" data-table-select="selected_count"></span>Selected
        </div>
        <button type="button" class="btn btn-sm btn-dark" data-table-select="delete_selected">Delete Selected</button>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-body border-bottom py-4" *ngIf="showFilters" [@slideInOut] style="background-color: var(--bs-gray-100); border-radius: 0.475rem;">
    <div class="row g-4">
      <!-- Stock Number -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Stock Number</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Enter Stock Number..."
          [(ngModel)]="filters.stock_number">
      </div>

      <!-- Chassis # -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Chassis #</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Enter Chassis #..."
          [(ngModel)]="filters.chassis_no">
      </div>

      <!-- Auction Hall -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Auction Hall</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Enter Auction Hall..."
          [(ngModel)]="filters.auction_hall">
      </div>

      <!-- Lot Number -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Lot Number</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Enter Lot Number..."
          [(ngModel)]="filters.lot_number">
      </div>
    </div>

    <!-- Second Row -->
    <div class="row g-4 mt-2">
      <!-- Yard In Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Yard In Date From</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.yard_in_date_from">
      </div>

      <!-- Yard In Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Yard In Date To</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.yard_in_date_to">
      </div>

      <!-- Purchase Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Purchase Date From</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.purchase_date_from">
      </div>

      <!-- Purchase Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Purchase Date To</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.purchase_date_to">
      </div>
    </div>

    <!-- Third Row -->
    <div class="row g-4 mt-2">
      <!-- Sailing From Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sailing From Date</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.sailing_from_date">
      </div>

      <!-- Sailing To Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sailing To Date</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.sailing_to_date">
      </div>

      <!-- Arrival From Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Arrival From Date</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.arrival_from_date">
      </div>

      <!-- Arrival To Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Arrival To Date</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.arrival_to_date">
      </div>
    </div>

    <!-- Fourth Row -->
    <div class="row g-4 mt-2">
      <!-- Ship Type -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Ship Type</label>
        <select
          class="form-select form-select-sm"
          [(ngModel)]="filters.ship_type">
          <option value="">Select Ship Type</option>
          <option value="roro">Roro</option>
          <option value="container">Container</option>
          <option value="ckd">CKD</option>
        </select>
      </div>

      <!-- Ship Name -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Ship Name</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Ship Name..."
            [(ngModel)]="shipSearchTerm"
            (input)="onShipSearchInput($event)"
            (focus)="onShipInputFocus()"
            (blur)="onShipInputBlur()"
            autocomplete="off" />

          <!-- Loading Spinner -->
          <div *ngIf="isShipSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
            <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
          </div>

          <!-- Dropdown Results -->
          <div *ngIf="showShipDropdown" class="dropdown-menu show position-absolute w-100 mt-1 shadow-sm border" style="z-index: 1050; max-height: 300px; overflow-y: auto;">
            <div *ngIf="shipSearchResults.length === 0 && !isShipSearching" class="dropdown-item-text text-muted text-center py-3">
              No ships found
            </div>
            <a
              *ngFor="let ship of shipSearchResults"
              href="javascript:void(0)"
              class="dropdown-item d-flex align-items-center py-2"
              (click)="selectShip(ship)">
              <div class="d-flex flex-column">
                <span class="fw-bold text-gray-800">{{ getShipDisplayName(ship) }}</span>
                <small class="text-muted">{{ ship.sailing_port }} → {{ ship.destination_port }}</small>
                <small class="text-muted">Sailing: {{ formatDate(ship.sailing_date) }}</small>
              </div>
            </a>
          </div>
        </div>
      </div>

      <!-- Carrier Name -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Carrier Name</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Enter Carrier Name..."
          [(ngModel)]="filters.carrier_name">
      </div>

      <!-- Voyage # -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Voyage #</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Enter Voyage #..."
          [(ngModel)]="filters.voyage_no">
      </div>
    </div>

    <!-- Fifth Row -->
    <div class="row g-4 mt-2">
      <!-- Search Client -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Search Client</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Client..."
            [(ngModel)]="clientSearchTerm"
            (input)="onClientSearchInput($event)"
            (focus)="onClientInputFocus()"
            (blur)="onClientInputBlur()"
            autocomplete="off" />

          <!-- Client Search Results Dropdown -->
          <div class="dropdown-menu show w-100 mh-300px overflow-auto"
               *ngIf="showClientDropdown && (clientSearchResults.length > 0 || isClientSearching)">

            <!-- Loading State -->
            <div class="dropdown-item text-center py-3" *ngIf="isClientSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching clients...
            </div>

            <!-- Search Results -->
            <a class="dropdown-item cursor-pointer py-2"
               *ngFor="let client of clientSearchResults"
               (click)="selectClient(client)">
              <div class="d-flex flex-column">
                <span class="fw-bold">{{ getClientDisplayName(client) }}</span>
                <small class="text-muted">{{ client.email }}</small>
              </div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
                 *ngIf="!isClientSearching && clientSearchResults.length === 0">
              No clients found
            </div>
          </div>
        </div>
      </div>

      <!-- Sales Person -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sales Person</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Sales Person..."
            [(ngModel)]="salesPersonSearchTerm"
            (input)="onSalesPersonSearchInput($event)"
            (focus)="onSalesPersonInputFocus()"
            (blur)="onSalesPersonInputBlur()"
            autocomplete="off" />

          <!-- Sales Person Search Results Dropdown -->
          <div class="dropdown-menu show w-100 mh-300px overflow-auto"
               *ngIf="showSalesPersonDropdown && (salesPersonSearchResults.length > 0 || isSalesPersonSearching)">

            <!-- Loading State -->
            <div class="dropdown-item text-center py-3" *ngIf="isSalesPersonSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching sales persons...
            </div>

            <!-- Search Results -->
            <a class="dropdown-item cursor-pointer py-2"
               *ngFor="let salesPerson of salesPersonSearchResults"
               (click)="selectSalesPerson(salesPerson)">
              <div class="d-flex flex-column">
                <span class="fw-bold">{{ getSalesPersonDisplayName(salesPerson) }}</span>
                <small class="text-muted">{{ salesPerson.email }}</small>
              </div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
                 *ngIf="!isSalesPersonSearching && salesPersonSearchResults.length === 0">
              No sales persons found
            </div>
          </div>
        </div>
      </div>

      <!-- Sailing Port -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sailing Port</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Enter Sailing Port..."
          [(ngModel)]="filters.sailing_port">
      </div>

      <!-- Destination Country -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Destination Country</label>
        <select
          class="form-select form-select-sm"
          [(ngModel)]="filters.destination_country"
          (change)="onDestinationCountryChange(filters.destination_country)">
          <option value="">Select Destination Country</option>
          <option *ngFor="let country of countries" [value]="country.code">
            {{ country.name }}
          </option>
        </select>
      </div>

      <!-- Destination Port -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Destination Port</label>
        <select
          class="form-select form-select-sm"
          [(ngModel)]="filters.destination_port"
          [disabled]="!filters.destination_country || isLoadingPorts">
          <option value="">Select Destination Port</option>
          <option *ngFor="let port of ports" [value]="port._id">
            {{ port.name }}
          </option>
        </select>
      </div>

      <!-- Yard -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Yard</label>
        <select
          class="form-select form-select-sm"
          [(ngModel)]="filters.yard">
          <option value="">Select Yard</option>
          <option *ngFor="let yard of yards" [value]="yard._id">
            {{ yard.company_name }}
          </option>
        </select>
      </div>
    </div>

    <!-- Filter Actions -->
    <div class="d-flex justify-content-end mt-4">
      <button
        type="button"
        class="btn btn-sm btn-light me-3"
        (click)="clearFilters()"
        [disabled]="!hasActiveFilters()">
        <i class="ki-duotone ki-cross fs-2">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Clear All
      </button>
      <button
        type="button"
        class="btn btn-sm btn-primary"
        (click)="applyFilters()">
        <i class="ki-duotone ki-magnifier fs-2">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Apply
      </button>
    </div>
  </div>

  <!-- Status Filter Tabs -->
  <div class="card-body py-3 border-bottom">
    <div class="d-flex align-items-center justify-content-end status-tabs">
      <div *ngFor="let status of statusOptions">
        <button type="button" class="status-tab" [class.active]="selectedStatus === status.value"
          (click)="onStatusFilter(status.value)">
          <span>{{ status.label }}</span>
          <!-- <span *ngIf="status.showShipTypes" class="ms-1 text-muted">
					[ Roro, Container, CKD ]
				</span> -->

        </button>
        <span *ngIf="status.showShipTypes" class="ms-1 text-muted">
          [
          <button *ngFor="let shipType of status.shipTypes" type="button" class="btn btn-sm me-2"
            [class.btn-primary]="selectedSubFilter === shipType.value"
            [class.btn-light]="selectedSubFilter !== shipType.value" (click)="onSubFilterSelect(shipType.value)">
            {{ shipType.label }}
          </button>
          ]
        </span>
        <span *ngIf="status.freightPaidTypes" class="ms-1 text-muted">
          [
          <button *ngFor="let freightPaidType of status.freightPaidTypes" type="button" class="btn btn-sm me-2"
            [class.btn-primary]="selectedFreightPaidSubFilter === freightPaidType.value"
            [class.btn-light]="selectedFreightPaidSubFilter !== freightPaidType.value" (click)="onSubFilterSelect(freightPaidType.value,'freight_paid')">
            {{ freightPaidType.label }}
          </button>
          ]
        </span>
      </div>
    </div>
  </div>

  <!-- PDF Format Selection (appears when invoices are selected) -->
  <!-- <div class="card-body py-3" *ngIf="showPdfOptions">
    <div class="alert alert-info d-flex align-items-center">
      <div class="d-flex flex-column flex-grow-1">
        <div class="d-flex align-items-center mb-2">
          <i class="ki-duotone ki-information-5 fs-2 text-info me-3">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </i>
          <span class="fw-bold fs-6">{{ getSelectedCount() }} invoice(s) selected</span>
        </div>
        <div class="d-flex align-items-center gap-3">
          <label class="form-label fs-7 fw-semibold mb-0">Select PDF Format:</label>
          <select class="form-select form-select-sm w-250px" [(ngModel)]="selectedPdfFormat"
            (change)="onPdfFormatChange()">
            <option value="">Choose format...</option>
            <option *ngFor="let format of pdfFormats" [value]="format.value">
              {{ format.label }}
            </option>
          </select>
          <button class="btn btn-sm btn-primary" [disabled]="!selectedPdfFormat" data-bs-toggle="modal"
            data-bs-target="#kt_modal_view_invoice" (click)="onPreviewPdf()">
            <i class="ki-duotone ki-eye fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
            </i>
            Preview PDF
          </button>
          <button class="btn btn-sm btn-success" (click)="copySelectedISL()">
            <i class="ki-duotone ki-copy fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Copy ISL#
          </button>
          <button class="btn btn-sm btn-light" (click)="onClearSelection()">
            <i class="ki-duotone ki-cross fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Clear Selection
          </button>
        </div>
      </div>
    </div>
  </div> -->

  <div class="card-body pt-0">
    <!-- Save Button (appears when changes are made) -->
    <div *ngIf="hasChanges" class="d-flex justify-content-end mb-3">
      <button type="button" class="btn btn-sm btn-success" (click)="onSave()" [disabled]="isLoading">
        <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        <i *ngIf="!isLoading" class="ki-duotone ki-check fs-2">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        {{ isLoading ? 'Saving...' : 'Save Changes' }}
      </button>
    </div>

    <!-- Invoice Table with Sticky Column -->
    <div *ngIf="!isLoading && invoices.length > 0" class="invoice-table-container">
      <div class="table-responsive">
        <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 invoice-table">
          <thead>
            <tr class="fw-bold text-muted bg-primary-subtle">
              <!-- Sticky Stock Number Column with Checkbox -->
              <th class="sticky-column min-w-200px">
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="isAllSelectedForCopy()"
                      [indeterminate]="isIndeterminateForCopy()"
                      (change)="toggleSelectAllForCopy($event)" />
                  </div>
                  Stock Number
                </div>
              </th>
              <!-- Scrollable Columns -->
              <th class="min-w-80px text-center">Docs</th>
              <th class="min-w-80px text-center">AR</th>
              <th class="min-w-150px">Chassis Number</th>
              <th class="min-w-150px">Book Request Date</th>
              <th class="min-w-100px">Paid %</th>
              <th class="min-w-120px">Sales Agent</th>
              <th class="min-w-150px">Agent Notes</th>
              <th class="min-w-120px">Yard Name</th>
              <th class="min-w-120px">Yard Date</th>
              <th class="min-w-150px">Destination Port</th>
              <th class="min-w-150px">Destination Country</th>
              <th class="min-w-120px">Masho Date</th>
              <th class="min-w-100px">Ship Type</th>
              <th class="min-w-120px">Group Number</th>
              <th class="min-w-150px">Ship Confirm Date</th>
              <th class="min-w-100px">Status</th>
              <th class="min-w-120px">Ship Id</th>
              <th class="min-w-120px">Ship Name</th>
              <th class="min-w-120px">Voyage Number</th>
              <th class="min-w-120px">Carrier Name</th>
              <th class="min-w-120px">Sailing Port</th>
              <th class="min-w-120px">Sailing Date</th>
              <th class="min-w-120px">Arrival Date</th>
              <th class="min-w-150px">Customer Name</th>
              <th class="min-w-100px">Terms</th>
              <th class="min-w-120px">Invoice Amount</th>
              <th class="min-w-80px">Currency</th>
              <th class="min-w-120px">Model Name</th>
              <th class="min-w-100px">Make</th>
              <th class="min-w-80px">Status</th>
              <th class="min-w-80px">L (cm)</th>
              <th class="min-w-80px">W (cm)</th>
              <th class="min-w-80px">H (cm)</th>
              <th class="min-w-80px">Weight</th>
              <th class="min-w-80px">M3</th>
              <th class="min-w-120px">Inspection Type</th>
              <th class="min-w-150px">Inspection Apply Date</th>
              <th class="min-w-120px">Inspection Status</th>
              <th class="min-w-150px">Inspection Pass Date</th>
              <th class="min-w-120px">Repair Status</th>
              <th class="min-w-150px">Repair Comp Date</th>
              <th class="min-w-120px">Container No</th>
              <th class="min-w-120px">Bl Number</th>
              <th class="min-w-100px">Vanning</th>
              <th class="min-w-120px">Seal Number</th>
              <th class="min-w-150px">Freight Paid Date</th>
              <th class="min-w-120px text-center">Ocean Freight</th>
              <th class="min-w-120px">Shipping Mark</th>
              <th class="min-w-120px">Auction Name</th>
              <th class="min-w-120px">Created By</th>
              <th class="min-w-100px">Lot Number</th>
              <th class="min-w-120px">Purchase Date</th>
              <th class="min-w-120px">Remark</th>
              <th class="min-w-80px">BTC Days</th>
              <th class="min-w-100px">Paid</th>
              <th class="min-w-100px">Balance</th>
              <th class="min-w-80px">Age</th>
              <th class="min-w-120px">Paid Date</th>
            </tr>
          </thead>
          <tbody>
            <!-- Loading state -->
            <tr *ngIf="isLoading">
              <td colspan="57" class="text-center py-5">
                <div class="d-flex align-items-center justify-content-center">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Loading invoices...
                </div>
              </td>
            </tr>

            <!-- No data state -->
            <tr *ngIf="!isLoading && invoices.length === 0">
              <td colspan="57" class="text-center py-5 text-muted">
                No invoices found
              </td>
            </tr>

            <!-- Data rows -->
            <tr *ngFor="let invoice of invoices; trackBy: trackByInvoiceId" class="invoice-row">
              <!-- Sticky Stock Number Column with Checkbox -->
              <td class="sticky-column">
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="isInvoiceSelectedForCopy(invoice._id)"
                      (change)="toggleInvoiceSelection(invoice._id, $event)" />
                  </div>
                  <span class="fw-bold text-primary">{{ invoice.vehicle?.car_no || '-' }}</span>
                </div>
              </td>

              <!-- Docs - Icon -->
              <td class="text-center">
                <a href="javascript:;" (click)="onDocsClick(invoice.vehicle?._id || '')">
                  <i class="ki-duotone ki-document fs-1 text-gray-800 text-hover-primary">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </a>
              </td>

              <!-- AR - Checkbox -->
              <td class="text-center">
                <div class="form-check form-check-sm form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox"
                    [ngModel]="getFormValue(invoice._id, 'ar')"
                    (ngModelChange)="setFormValue(invoice._id, 'ar', $event)" />
                </div>
              </td>

              <!-- Chassis Number -->
              <td class="text-nowrap">{{ invoice.vehicle?.vin_no || '-' }}</td>

              <!-- Book Request Date - Input -->
              <td>
                <input type="text" class="form-control form-control-sm"
                  [ngModel]="getFormValue(invoice._id, 'book_request_date')"
                  (ngModelChange)="setFormValue(invoice._id, 'book_request_date', $event)"
                  placeholder="Enter date" />
              </td>

              <!-- Paid % -->
              <td class="text-nowrap">{{ calculatePaidPercentage(invoice.paid, invoice.invoice_amount) }}</td>

              <!-- Sales Agent -->
              <td class="text-nowrap">{{ invoice.order?.created_by?.name || '-' }}</td>

              <!-- Agent Notes -->
              <td class="text-nowrap">{{ invoice.agent_notes || '-' }}</td>

              <!-- Yard Name -->
              <td class="text-nowrap">{{ invoice.vehicle?.yard_name || '-' }}</td>

              <!-- Yard Date -->
              <td class="text-nowrap">{{ formatDate(invoice.vehicle?.yard_date) }}</td>

              <!-- Destination Port -->
              <td class="text-nowrap">{{ invoice.order?.to_port || '-' }}</td>

              <!-- Destination Country -->
              <td class="text-nowrap">{{ invoice.order?.to_country || '-' }}</td>

              <!-- Masho Date -->
              <td class="text-nowrap">
                <button type="button"
                        class="form-control form-control-sm text-start border-0 bg-transparent p-2"
                        style="cursor: pointer; min-width: 120px;"
                        (click)="openMashoModal(invoice.vehicle)"
                        [disabled]="!invoice.vehicle">
                  {{ invoice.vehicle?.masho_apply_date ? formatDate(invoice.vehicle.masho_apply_date) : '-' }}
                </button>
              </td>

              <!-- Ship Type - Radio buttons -->
              <td>
                <div class="d-flex gap-2">
                  <div class="form-check form-check-sm">
                    <input class="form-check-input" type="radio"
                      [name]="'ship_type_' + invoice._id"
                      [checked]="invoice.order?.ship_type === 'Roro'"
                      disabled />
                    <label class="form-check-label">R</label>
                  </div>
                  <div class="form-check form-check-sm">
                    <input class="form-check-input" type="radio"
                      [name]="'ship_type_' + invoice._id"
                      [checked]="invoice.order?.ship_type === 'Container'"
                      disabled />
                    <label class="form-check-label">C</label>
                  </div>
                  <div class="form-check form-check-sm">
                    <input class="form-check-input" type="radio"
                      [name]="'ship_type_' + invoice._id"
                      [checked]="invoice.order?.ship_type !== 'Roro' && invoice.order?.ship_type !== 'Container'"
                      disabled />
                    <label class="form-check-label">CKD</label>
                  </div>
                </div>
              </td>

              <!-- Group Number -->
              <td class="text-nowrap">{{ invoice.order?.group_no || '-' }}</td>

              <!-- Ship Confirm Date -->
              <td class="text-nowrap">{{ invoice.shipping_info?.ship_confirm_date ? formatDate(invoice.shipping_info?.ship_confirm_date) : '-' }}</td>

              <!-- Status - Select -->
              <td>
                <select class="form-select form-select-sm"
                  [ngModel]="getFormValue(invoice._id, 'status')"
                  (ngModelChange)="setFormValue(invoice._id, 'status', $event)">
                  <option value="">Select status</option>
                  <option value="pending">Pending</option>
                  <option value="confirmed">Confirmed</option>
                </select>
              </td>

              <!-- Ship Id -->
              <td class="text-nowrap">{{ invoice.ship?.ship_id || '-' }}</td>

              <!-- Ship Name -->
              <td class="text-nowrap">{{ invoice.ship?.name || '-' }}</td>

              <!-- Voyage Number -->
              <td class="text-nowrap">{{ invoice.ship?.voyage_no || '-' }}</td>

              <!-- Carrier Name -->
              <td class="text-nowrap">{{ invoice.ship?.company || '-' }}</td>

              <!-- Sailing Port -->
              <td class="text-nowrap">{{ invoice.ship?.sailing_port || '-' }}</td>

              <!-- Sailing Date -->
              <td class="text-nowrap">{{ formatDate(invoice.ship?.sailing_date) }}</td>

              <!-- Arrival Date -->
              <td class="text-nowrap">{{ formatDate(invoice.ship?.arrival_date) }}</td>

              <!-- Customer Name -->
              <td class="text-nowrap">{{ invoice.order?.buyer_consignee_name || '-' }}</td>

              <!-- Terms - Select -->
              <td>
                <select class="form-select form-select-sm"
                  [ngModel]="getFormValue(invoice._id, 'terms')"
                  (ngModelChange)="setFormValue(invoice._id, 'terms', $event)">
                  <option value="">Select terms</option>
                  <option value="C&F">C&F</option>
                  <option value="CIF">CIF</option>
                  <option value="FOB">FOB</option>
                  <option value="CKD">CKD</option>
                  <option value="Local">Local</option>
                  <option value="Auction Deposit">Auction Deposit</option>
                </select>
              </td>

              <!-- Invoice Amount -->
              <td class="text-nowrap">{{ formatCurrency(+invoice.invoice_amount, invoice.item?.currency) }}</td>

              <!-- Currency -->
              <td class="text-nowrap">{{ invoice.item?.currency === 'USD' ? '$' : '¥' }}</td>

              <!-- Model Name -->
              <td class="text-nowrap">{{ invoice.vehicle?.name || '-' }}</td>

              <!-- Make -->
              <td class="text-nowrap">{{ invoice.vehicle?.company_name || '-' }}</td>

              <!-- Status -->
              <td class="text-nowrap">{{ getInvoiceStatus(invoice) }}</td>

              <!-- L (cm) -->
              <td class="text-nowrap">{{ invoice.vehicle?.car_length || '-' }}</td>

              <!-- W (cm) -->
              <td class="text-nowrap">{{ invoice.vehicle?.car_width || '-' }}</td>

              <!-- H (cm) -->
              <td class="text-nowrap">{{ invoice.vehicle?.car_height || '-' }}</td>

              <!-- Weight -->
              <td class="text-nowrap">{{ invoice.vehicle?.weight || '-' }}</td>

              <!-- M3 -->
              <td class="text-nowrap">{{ invoice.vehicle?.m3 || '-' }}</td>

              <!-- Inspection Type -->
              <td class="text-nowrap">-</td>

              <!-- Inspection Apply Date -->
              <td class="text-nowrap">{{invoice.vehicle.inspection_apply_date ? formatDate(invoice.vehicle.inspection_apply_date) : '-' }}</td>

              <!-- Inspection Status -->
              <td class="text-nowrap">{{invoice?.vehicle?.inspection_status || '-' }}</td>

              <!-- Inspection Pass Date -->
              <td class="text-nowrap">{{invoice.vehicle?.inspection_passed_date ? formatDate(invoice.vehicle.inspection_passed_date) : '-' }}</td>

              <!-- Repair Status -->
              <td class="text-nowrap">{{invoice.vehicle?.repair_status || '-' }}</td>

              <!-- Repair Comp Date -->
              <td class="text-nowrap">{{invoice.vehicle?.repair_complete_date ? formatDate(invoice.vehicle.repair_complete_date) : '-' }}</td>

              <!-- Container No - Input -->
              <td>
                <input type="text" class="form-control form-control-sm"
                  [ngModel]="getFormValue(invoice._id, 'container_no')"
                  (ngModelChange)="setFormValue(invoice._id, 'container_no', $event)"
                  placeholder="Enter container no" />
              </td>

              <!-- Bl Number - Input -->
              <td>
                <input type="text" class="form-control form-control-sm"
                  [ngModel]="getFormValue(invoice._id, 'bl_number')"
                  (ngModelChange)="setFormValue(invoice._id, 'bl_number', $event)"
                  placeholder="Enter BL number" />
              </td>

              <!-- Vanning - Select -->
              <td>
                <select class="form-select form-select-sm"
                  [ngModel]="getFormValue(invoice._id, 'vanning')"
                  (ngModelChange)="setFormValue(invoice._id, 'vanning', $event)">
                  <option value="">Select vanning</option>
                  <option value="option1">Option 1</option>
                  <option value="option2">Option 2</option>
                  <option value="option3">Option 3</option>
                </select>
              </td>

              <!-- Seal Number - Input -->
              <td>
                <input type="text" class="form-control form-control-sm"
                  [ngModel]="getFormValue(invoice._id, 'seal_number')"
                  (ngModelChange)="setFormValue(invoice._id, 'seal_number', $event)"
                  placeholder="Enter seal number" />
              </td>

              <!-- Freight Paid Date -->
              <td class="text-nowrap">{{ invoice.vehicle?.freight_paid_date ? formatDate(invoice.vehicle?.freight_paid_date) : '-' }}</td>

              <!-- Ocean Freight - Docs Icon -->
              <td class="text-center">
                <a href="javascript:;" (click)="onOceanFreightClick(invoice._id)">
                  <i class="ki-duotone ki-document fs-1 text-gray-800 text-hover-primary">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </a>
              </td>

              <!-- Shipping Mark - Input -->
              <td>
                <input type="text" class="form-control form-control-sm"
                  [ngModel]="getFormValue(invoice._id, 'shipping_mark')"
                  (ngModelChange)="setFormValue(invoice._id, 'shipping_mark', $event)"
                  placeholder="Enter shipping mark" />
              </td>

              <!-- Auction Name -->
              <td class="text-nowrap">{{ invoice.vehicle?.auction_name || '-' }}</td>

              <!-- Created By -->
              <td class="text-nowrap">{{ invoice.created_by?.name || '-' }}</td>

              <!-- Lot Number -->
              <td class="text-nowrap">{{ invoice.vehicle?.lot_number || '-' }}</td>

              <!-- Purchase Date -->
              <td class="text-nowrap">{{ formatDate(invoice.order?.created_at) }}</td>

              <!-- Remark - Input -->
              <td>
                <input type="text" class="form-control form-control-sm"
                  [ngModel]="getFormValue(invoice._id, 'remark')"
                  (ngModelChange)="setFormValue(invoice._id, 'remark', $event)"
                  placeholder="Enter remark" />
              </td>

              <!-- BTC Days -->
              <td class="text-nowrap">-</td>

              <!-- Paid -->
              <td class="text-nowrap">{{ formatCurrency(+invoice.paid, invoice.item?.currency) }}</td>

              <!-- Balance -->
              <td class="text-nowrap">{{ formatCurrency(+invoice.balance, invoice.item?.currency) }}</td>

              <!-- Age -->
              <td class="text-nowrap">{{ getAge(invoice) }}</td>

              <!-- Paid Date -->
              <td class="text-nowrap">-</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Loading state (outside table) -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="d-flex align-items-center justify-content-center">
        <span class="spinner-border spinner-border-sm me-2"></span>
        Loading invoices...
      </div>
    </div>

    <!-- No data state (outside table) -->
    <div *ngIf="!isLoading && invoices.length === 0" class="text-center py-5 text-muted">
      No invoices found
    </div>
  </div>

  <!-- Pagination -->
  <div class="row" *ngIf="!isLoading && invoices.length > 0">
    <div class="col-sm-6 py-4 d-flex align-items-center">
      <div class="text-muted">
        Showing {{ ((paginationInfo.currentPage - 1) * paginationInfo.perPage) + 1 }}
        to {{ Math.min(paginationInfo.currentPage * paginationInfo.perPage, paginationInfo.total) }}
        of {{ paginationInfo.total }} records
      </div>
    </div>
    <div class="col-sm-6 py-4 d-flex justify-content-end">
      <nav aria-label="pagination" class="dt-paging paging_full">
        <ul class="pagination">
          <!-- First page -->
          <li class="dt-paging-button page-item" [class.disabled]="paginationInfo.currentPage === 1">
            <button type="button" class="btn btn-sm btn-primary page-link first"
              [disabled]="paginationInfo.currentPage === 1" (click)="onPageChange(1)">
              <i class="ki-duotone ki-double-left">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </button>
          </li>

          <!-- Previous page -->
          <li class="dt-paging-button page-item" [class.disabled]="paginationInfo.currentPage === 1">
            <button type="button" class="btn btn-sm btn-primary page-link previous"
              [disabled]="paginationInfo.currentPage === 1" (click)="onPageChange(paginationInfo.currentPage - 1)">
              <i class="ki-duotone ki-left"></i>
            </button>
          </li>

          <!-- Page numbers -->
          <li class="dt-paging-button page-item" *ngFor="let page of getPageNumbers()"
            [class.active]="page === paginationInfo.currentPage">
            <button type="button" class="btn btn-sm btn-primary page-link"
              [attr.aria-current]="page === paginationInfo.currentPage ? 'page' : null" (click)="onPageChange(page)">
              {{ page }}
            </button>
          </li>

          <!-- Next page -->
          <li class="dt-paging-button page-item"
            [class.disabled]="paginationInfo.currentPage === paginationInfo.lastPage">
            <button type="button" class="btn btn-sm btn-primary page-link next"
              [disabled]="paginationInfo.currentPage === paginationInfo.lastPage"
              (click)="onPageChange(paginationInfo.currentPage + 1)">
              <i class="ki-duotone ki-right"></i>
            </button>
          </li>

          <!-- Last page -->
          <li class="dt-paging-button page-item"
            [class.disabled]="paginationInfo.currentPage === paginationInfo.lastPage">
            <button type="button" class="btn btn-sm btn-primary page-link last"
              [disabled]="paginationInfo.currentPage === paginationInfo.lastPage"
              (click)="onPageChange(paginationInfo.lastPage)">
              <i class="ki-duotone ki-double-right">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>

<!-- Invoice PDF Preview Modal -->

<!-- Invoice Detail Modal -->
<app-invoice-detail-modal [invoice]="selectedInvoiceForDetail" [invoiceId]="selectedInvoiceIdForDetail">
</app-invoice-detail-modal>

<!-- Vehicle Upload Documents Modal -->
<app-vehicle-upload-documents>
</app-vehicle-upload-documents>

<!-- Vehicle Price Sheet Modal -->
<app-vh-price-sheet>
</app-vh-price-sheet>

<!-- Masho Manager Add/Edit Modal -->
<app-masho-manager-add-edit>
</app-masho-manager-add-edit>

<!-- Shipping Export Fields Modal -->
<app-shipping-export-fields-modal (exportRequested)="exportExcelWithSelectedFields($event)">
</app-shipping-export-fields-modal>

<!-- Send Shipping Mail Modal -->
<app-send-shipping-mail-modal>
</app-send-shipping-mail-modal>
